module.exports = __webpack_public_path__ + "ac7316fdddda88588d6c2626de7b2d85.svg";